import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import Button from '../blocks/button/Button';
import FormField from './../blocks/form-field/FormField';
import PasswordField from './../blocks/form-field/PasswordField';
import Form from '../blocks/form-blocks/Form';

import { formSubmit, postAuth, postRestore, setInitialState } from './../actions/auth-action'
import { emailHandler, passwordHandler } from './../validators/form-validators';
import { clearFields } from '../actions/field-action';
import './style.css';


class Authorization extends Component {

  state = {
    isFormAuth: true
  };

  componentWillMount() {
    if (this.props.participantView.userShortView || !this.props.withServer) {
      browserHistory.push('/');
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    this.props.setInitialState();
    this.props.clearFields();
  }

  onRestorePassword(e) {
    e.preventDefault();
    this.setState({isFormAuth: false});
  }
  onAuthForm(e) {
    e.preventDefault();
    this.setState({isFormAuth: true});
  }

  afterValidation() {
    if (this.props.isValidated) {
      if (this.state.isFormAuth) {
        let data = this.props.fields;
        this.props.postAuth(`j_username=${data['j_username']}&j_password=${data['j_password']}`);
      } else {
        this.props.postRestore(new FormData(this.refs.form.refs.form));
      }
    }
  }
  beforeFormSubmit() {
    this.props.formSubmit();
  }

  render() {

    if (this.props.participantView.userShortView || !this.props.withServer) {
      browserHistory.push('/');
    }

    let that = this;

    if (this.props.afterValidate) {
      this.afterValidation();
    }
    if (this.props.successRestore) {
      setTimeout(() => {
        that.props.setInitialState();
        browserHistory.push('/');
      }, 5000);
    }
    let formContent;
    if (this.state.isFormAuth) {
      formContent = (
        <Form
          title='Вход на сайт'
          ref='form'
          name='loginForm'
        >
          <div className='authorization__error'>{this.props.failMessage}</div>
          <div className='authorization__field'>
            <FormField
              title='Email' type='text' fieldName='j_username'
              errorHandler={emailHandler} ref='email' key='j_username'
            />
            <PasswordField
              title='Пароль' fieldName='j_password' key='j_password'
              errorHandler={passwordHandler} ref='password'
            />
          </div>
          <div className='authorization__link'>
            <div className='authorization__link-text' onClick={this.onRestorePassword.bind(this)}>Забыли пароль?</div>
          </div>
          <Button
            styleClasses={['authorization__button']}
            onClick={(e) => {
              e.preventDefault();
              this.beforeFormSubmit();
            }}
          >
            Войти
          </Button>
        </Form>
      );
    } else {
      formContent = (
        <Form
          title='Восстановление пароля'
          ref='form'
          name='restoreRequestForm'
          successMessage={this.props.successMessage}
        >
          <div className='authorization__field'>
            <FormField
              title='Email' type='text' fieldName='email'
              errorHandler={emailHandler} ref='email' key='email'
            />
          </div>
          <div className='authorization__link' >
            <div className='authorization__link-text' onClick={this.onAuthForm.bind(this)}>Вернуться ко входу</div>
          </div>
          <Button
            onClick={(e) => {
              e.preventDefault();
              this.beforeFormSubmit();
            }}
            styleClasses={['authorization__button']}
          >
            Восстановить
          </Button>
        </Form>
      );
    }
    return (
      <div className='authorization'>
        {formContent}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  successRestore: state.auth.successRestore,
  isValidated: state.auth.isValidated,
  afterValidate: state.auth.afterValidate,
  failMessage: state.auth.failMessage,
  successMessage: state.auth.successMessage,
  participantView: state.participant.participantView,
  fields: state.fields,
  withServer: state.participant.withServer
});

const mapDispatchToProps = (dispatch) => ({
  formSubmit: bindActionCreators(formSubmit, dispatch),
  postAuth: bindActionCreators(postAuth, dispatch),
  postRestore: bindActionCreators(postRestore, dispatch),
  setInitialState: bindActionCreators(setInitialState, dispatch),
  clearFields: bindActionCreators(clearFields, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Authorization);



// WEBPACK FOOTER //
// ./src/authorization-page/Authorization.js